import React, { useContext, useEffect, useState } from 'react';
import {
  Routes,
  Route
} from "react-router-dom";
import './shop.scss';
import { Link } from "react-router-dom";
import axios from 'axios';
import ArticleList from '../../components/articleList/articleList';
import { ArticleContext } from '../../components/context';
import Article from '../../components/article/article';
import Warenkorb from '../../components/cart/cart';
import Spinner from './../../assets/images/spinner.svg'
import { useSearchParams } from 'react-router-dom';
import { STRAPI_URL } from '../../config/env';

export default function Shop({ homepageData = {} }) {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const mitglied = searchParams.get('mitglied');
    const abholung = searchParams.get('abholung');

    if (mitglied === '1') {
      window.sessionStorage.setItem("mitglied", true);
    } else if (mitglied === '0') {
      window.sessionStorage.setItem("mitglied", false);
    }

    if (abholung === '1') {
      window.sessionStorage.setItem("abholung", true);
    } else if (abholung === '0') {
      window.sessionStorage.setItem("abholung", false);
    }
  }, [searchParams]);

  const [loading, setLoading] = useState(true);
  const { setArticleData, setProductgroupData } = useContext(ArticleContext);
  useEffect(() => {
    const fetchArticleData = async () => {
      try {
        const { data: response } = await axios.get(`${STRAPI_URL}/api/produkte?populate=deep`);
        setArticleData(response.data);
      } catch (error) {
        console.error(error.message);
      }
    }

    const fetchProductgroupData = async () => {
      try {
        const { data: response } = await axios.get(`${STRAPI_URL}/api/produktgruppes?populate=deep`);
        setProductgroupData(response.data);
      } catch (error) {
        console.error(error.message);
      }
    }

    setLoading(true)
    Promise.all([
      fetchArticleData(),
      fetchProductgroupData()
    ]).finally(() => {
      setLoading(false)
    })
  }, [setArticleData, setProductgroupData]);
  return (
    <div className="shopSection">
      <ul className='navigation' role="navigation" aria-label="shopNavigation">
        <li><Link to="/shop/Alles">Alles&nbsp;</Link></li>
        <li><Link to="/shop/Tickets">Tickets&nbsp;</Link></li>
        <li><Link to="/shop/Textil">Textil&nbsp;</Link> </li>
        <li><Link to="/shop/Merch">Merch&nbsp;</Link></li>
        {
          //<li><Link className='bakStyle' to="/shop/BAK">BAK</Link></li>
        }
      </ul>
      {loading && <div className='loading'><img src={Spinner} alt="loading animation" /></div>}
      {!loading && (
        <Routes>
          <Route path=":id" element={<ArticleList homepageData={homepageData} />} />
          <Route path="warenkorb" element={<Warenkorb />} />
          <Route path="artikel/:id" element={<Article />} />
        </Routes>
      )}
    </div>
  );
}
